import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import '../DailyView.scss';

const HeaderTable = ({ ubication, tableTemplate, isSDS }) => (
  <Row className="mt-1 header_line_table d-flex align-items-center">
    {ubication && (
      <>
        <Col className="gy-0" sm={8}>
          Ubicación
        </Col>
        <Col sm={2}>Cantidad</Col>
      </>
    )}
    {tableTemplate && (
      <>
        <Col className="gy-0 d-flex" sm={!isSDS ? 4 : 5}>
          Posición
        </Col>
        <Col className="d-flex" sm={!isSDS ? 3 : 4}>
          Línea
        </Col>
        <Col className=" d-flex" sm={1}>
          UM
        </Col>
        <Col className="d-flex" sm={1}>
          Cantidad
        </Col>
        {!isSDS && (
          <>
            <Col className="justify-content-center d-flex" sm={1}>
              On Call
            </Col>
            <Col className="justify-content-center d-flex" sm={1}>
              Mensualizada
            </Col>
          </>
        )}
      </>
    )}

    <Col sm={tableTemplate ? 1 : 2} />
  </Row>
);

HeaderTable.propTypes = {
  isSDS: PropTypes.bool,
  tableTemplate: PropTypes.bool,
  ubication: PropTypes.bool
};

HeaderTable.defaultProps = {
  isSDS: false,
  tableTemplate: false,
  ubication: false
};

export default HeaderTable;
